import { uuid } from './util';
export var MessageType;
(function (MessageType) {
    MessageType["Request"] = "request";
    MessageType["Respond"] = "respond";
    MessageType["Callback"] = "callback";
})(MessageType || (MessageType = {}));
export class Message {
    constructor(newMessage) {
        this.type = newMessage.type;
        this.namespace = newMessage.namespace;
        this.name = newMessage.name;
        this.payload = newMessage.payload;
        this.correlationId = newMessage.correlationId || uuid();
    }
}
//# sourceMappingURL=message.js.map